import LoginForm from 'src/sections/auth/login-form';

export default function LoginPage() {
  return <LoginForm />;
}
